<div #card class="card card-default">
  <div class="card-header z-0" (click)="isCollapsed = !isCollapsed">
    <div class="card-title noselect" [class.collapsed]="isCollapsed">
      {{ title }}
      <ng-content select="[header-badge]"></ng-content>
    </div>
  </div>
  <div class="card-body" [ngbCollapse]="isCollapsed">
    <ng-content></ng-content>
  </div>
</div>
